import React from "react";
import { useNavigate } from "react-router-dom";

function HearroMyPageModifyProfile() {
    const navigate = useNavigate();

    const handleDownloadFile = () => {
        const downloadURL = process.env.REACT_APP_MODIFY_DOC_URL_HEARRO;
        window.open(downloadURL, "_blank");
    }
   
    return (
        <div className="signinLayout" style={{ width: '100%', height: '100%', background: 'white' }}>
			<div className="signinLayout__wrapper">
				<div className="signinLayout__wrapper__header" style={{margin: '0'}}>
                    <span className="signinLayout__wrapper__header__title">회원정보 수정</span>
                </div>
                <div className="signinLayout__wrapper__body">
                    <div className="signinLayout__wrapper_body__text" style={{ paddingLeft: '0', paddingRight: '0', whiteSpace: 'nowrap' }}>
                        회원정보 수정 양식서를 작성하여 digitalpharm@dgtpharm.com 로 메일 보내주세요.
                    </div>
                    <div className="signinLayout__wrapper__body__footer multiple">
						<button
							className="submitButton"
                            onClick={handleDownloadFile}
						>
							양식 다운로드
						</button>
                        <button
							className="cancelButton"
                            onClick={() => navigate("/dtx002/mypage")}
						>
							되돌아가기
						</button>
					</div>
                </div>
            </div>
        </div>
    )
}

export default HearroMyPageModifyProfile;